/* eslint-disable @typescript-eslint/ban-types */
import { FormSectionWrap } from "@components/UI/atoms/Forms/FormComponents";
import V2StyledFormTitle from "@components/UIv2/atoms/V2StyledFormTitle";
import { Box, TextField, Typography } from "@mui/material";
import { Control, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

type Props = {
  control: Control<any, object>;
};

export const Duration = ({ control }: Props) => {
  const { t } = useTranslation("common");
  return (
    <FormSectionWrap>
      <V2StyledFormTitle isHideTag title={t("duration")} />
      <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
        <Controller
          control={control}
          name="duration"
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <TextField
              type="number"
              variant="outlined"
              placeholder={t("duration")}
              error={!!error}
              helperText={error ? error.message : null}
              value={value}
              onChange={onChange}
            />
          )}
          rules={{
            min: { value: 0, message: t("min_message") },
          }}
        />
        <Typography>{t("min")}</Typography>
      </Box>
    </FormSectionWrap>
  );
};
